import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Pin, PinOff } from "lucide-react";
import { COCKPIT } from "../../constants/testIds";
import { useAppData } from "../../contexts/AppDataContext";

const CANDIDATES = [
  { key: "members", label: "Members", path: "/app/members" },
  { key: "money", label: "Money", path: "/app/money" },
  { key: "staff", label: "Staff", path: "/app/staff" },
  { key: "reports", label: "Reports", path: "/app/reports" },
  { key: "plans", label: "Plans", path: "/app/plans" },
];
const DEFAULT_PINS = ["members", "money"];

// UI_STANDARDS.md A "Quick Actions / Favorites (WOW-013)": per-user pinned quick links. No
// per-user backend field exists for this (and this prompt forbids adding one) — persisted in
// localStorage keyed by user id, which still delivers the real per-user behavior on this device.
export function QuickActions() {
  const { me } = useAppData();
  const storageKey = `fitfrik-quick-actions-${me?.id || "anon"}`;
  const [pinned, setPinned] = useState(DEFAULT_PINS);

  useEffect(() => {
    const stored = localStorage.getItem(storageKey);
    if (stored) setPinned(JSON.parse(stored));
  }, [storageKey]);

  const togglePin = (key) => {
    const next = pinned.includes(key) ? pinned.filter((k) => k !== key) : [...pinned, key];
    setPinned(next);
    localStorage.setItem(storageKey, JSON.stringify(next));
  };

  return (
    <div data-testid={COCKPIT.quickActionsRow} className="flex items-center gap-2 flex-wrap">
      <span className="eyebrow">Quick actions</span>
      {CANDIDATES.map((c) => {
        const isPinned = pinned.includes(c.key);
        return (
          <div key={c.key} className="flex items-center gap-1">
            {isPinned && (
              <Link to={c.path} className="text-xs font-semibold px-3 py-1.5 rounded-full scarlet-focusable" style={{ background: "var(--scarlet-accent-tint)", color: "var(--scarlet-accent)" }}>
                {c.label}
              </Link>
            )}
            <button
              data-testid={COCKPIT.quickActionPin(c.key)}
              onClick={() => togglePin(c.key)}
              className="scarlet-focusable opacity-40 hover:opacity-100 transition-opacity"
              aria-label={isPinned ? `Unpin ${c.label}` : `Pin ${c.label}`}
            >
              {isPinned ? <PinOff size={12} /> : <Pin size={12} />}
            </button>
          </div>
        );
      })}
    </div>
  );
}
